// extracted by mini-css-extract-plugin
module.exports = {"modal":"UnloadPrompt_modal__3XdEj","image":"UnloadPrompt_image__3-VWb","text":"UnloadPrompt_text__3gbyd","buttonGroup":"UnloadPrompt_buttonGroup__2sgpP"};